import { usePublicSiteContent } from "../../../hooks/useSiteContent";
import { telHref, whatsappUrl } from "../../../lib/siteContentStore";

export default function ContactSection() {
  const content = usePublicSiteContent();

  return (
    <section id="iletisim" className="bg-farm-warm py-16 px-4">
      <div className="max-w-6xl mx-auto rounded-[28px] border border-farm-border bg-farm-cream p-6 md:p-8 shadow-sm">
        <div className="mb-6">
          <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">
            İLETİŞİM VE KONUM
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl font-bold text-farm-brown">
            Bize ulaşın, konumu görüntüleyin
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
          <a href={`tel:${telHref(content)}`} className="rounded-2xl bg-farm-warm border border-farm-border p-5 hover:shadow-sm transition-shadow">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-farm-earth-light text-farm-brown">
              <i className="ri-phone-line text-xl" />
            </div>
            <p className="mt-4 font-heading text-xl font-bold text-farm-brown">{content.contactPhone}</p>
            <p className="font-body text-sm text-farm-muted">Telefon ile iletişim</p>
          </a>

          <a href={whatsappUrl(content)} target="_blank" rel="nofollow noopener" className="rounded-2xl bg-farm-warm border border-farm-border p-5 hover:shadow-sm transition-shadow">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-farm-green-pale text-farm-green">
              <i className="ri-whatsapp-line text-2xl" />
            </div>
            <p className="mt-4 font-heading text-xl font-bold text-farm-brown">WhatsApp</p>
            <p className="font-body text-sm text-farm-muted">Kayıt işlemleri WhatsApp üzerinden yapılmaktadır.</p>
          </a>

          <div className="rounded-2xl bg-farm-warm border border-farm-border p-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-farm-gold-pale text-farm-gold">
              <i className="ri-truck-line text-xl" />
            </div>
            <p className="mt-4 font-heading text-xl font-bold text-farm-brown">Avrupa Bölgesi</p>
            <p className="font-body text-sm text-farm-muted">İsteğe göre teslimat planlaması yapılır.</p>
          </div>

          <a
            href={content.mapsUrl || "#"}
            target="_blank"
            rel="nofollow noopener"
            className="rounded-2xl bg-farm-warm border border-farm-border p-5 hover:shadow-sm transition-shadow"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-farm-earth-light text-farm-brown">
              <i className="ri-map-pin-line text-xl" />
            </div>
            <p className="mt-4 font-heading text-xl font-bold text-farm-brown">Konum</p>
            <p className="font-body text-sm text-farm-muted whitespace-pre-line">
              {content.address || "Çatalca – İnceğiz Yolu\nİstanbul, Türkiye"}
            </p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-farm-earth">
              Yol Tarifi Al
              <i className="ri-arrow-right-line" />
            </span>
          </a>

          <div className="rounded-2xl bg-farm-warm border border-farm-border p-5">
            <p className="font-heading text-xl font-bold text-farm-brown">Bizi Takip Edin</p>
            <p className="mt-1 font-body text-sm text-farm-muted">Facebook ve Instagram hesaplarımız.</p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#" className="flex h-11 w-11 items-center justify-center rounded-full bg-farm-brown text-white hover:bg-farm-earth transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl" />
              </a>
              <a href="#" className="flex h-11 w-11 items-center justify-center rounded-full bg-farm-brown text-white hover:bg-farm-earth transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line text-xl" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
